export default "__VITE_ASSET__CvoeKVFd__"